







































import Vue from "vue";
import { mapGetters } from "vuex";

// Vue Components
import InstallationTreePathWithResumeDialog from "@/components/InstallationTreePathWithResumeDialog.vue";
import TransactionPropsList from "@/components/PropsLists/TransactionPropsList.vue";
import DataFlowFeedbacksTimeline from "@/views/App/CashFlow/CashReport/DataFlowFeedbacksTimeline.vue";
import CashDetailsCard from "./CashDetailsCard.vue";

// Model
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { Transaction } from "@/model/data/cashFlow/Transaction";
import { TransactionFlowEnum } from "@/model/data/enums/TransactionFlowEnum";
import { formatCurrency } from "@/utility/Formatter";

export default Vue.extend({
    components: {
        TransactionPropsList,
        CashDetailsCard,
        DataFlowFeedbacksTimeline,
        InstallationTreePathWithResumeDialog,
    },
    data() {
        return {
            TransactionFlowEnum,
        };
    },
    props: {
        transaction: Transaction,
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        isUserAllowedToSeeDataflowFeedbacks() {
            return this.authUserHasPrivilege(ClientPrivileges.DataFlowFeedbacksViewer);
        },
    },
    methods: {
        formatCurrency,
    },
});
